<template>
  <div class='SelectSlide'>
    <div class="btn" @click="$refs.in.click()">Adicione imagens</div>
    <div class="imgs">
      <carousel :items-to-show="1">
        <slide v-for="(img, key) in slide.length ? slide : [{ id: '', img: 1 }]" :key="key">
          <div class="cont-img">
            <img v-if="slide.length" :src="api + img.img">
            <img-icon v-if="!slide.length" :options="{ width: '30px', height: '20px', color: '#CCCCCC' }"/>
            <delete-icon @click="Del(img.id)" v-if="slide.length" :options="{ width: '20px', height: '20px' }"/>
          </div>
        </slide>
        <template #addons>
          <navigation />
        </template>
      </carousel>
    </div>
    <input ref="in" v-show="false" type="file" @change="inFile"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Navigation } from 'vue3-carousel'
import DeleteIcon from '../Icons/DeleteIcon'
import ImgIcon from '../Icons/ImgIcon'
import api from '@/mixins/api'
import compressImage from '@/mixins/compressImage'
export default {
  name: 'SelectSlide',
  components: { Carousel, Slide, Navigation, DeleteIcon, ImgIcon },
  mixins: [api, compressImage],
  data () {
    return {
      slide: []
    }
  },
  methods: {
    ...mapActions(['_CreateFrenteLojaSlideImg', '_DeleteFrenteLojaSlideImg', 'GetFrenteLojaSlideImg']),
    inFile (e) {
      for (let key in e.target.files) {
        if (key !== 'length' && key !== 'item') {
          this.getBase64(e.target.files[key])
        }
      }
    },
    getBase64 (file) {
      let reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = async () => {
        this._CreateFrenteLojaSlideImg({ img: await this.compressImage(reader.result), filename: file.name })
          .then(res => {
            this.slide.push(res)
          })
      }
      reader.onerror = (error) => {
        console.log('Error: ', error)
      }
    },
    Del (id) {
      this._DeleteFrenteLojaSlideImg({ id: id })
        .then(() => {
          this.slide = this.slide.filter(i => i.id !== id)
        })
    }
  },
  created () {
    this.GetFrenteLojaSlideImg()
     .then(res => {
      this.slide = res
     })
  }
}
</script>

<style scoped>
.SelectSlide {
  display: flex;
  align-items: center;
  gap: 12px;
}

.btn {
  flex: 1;
  text-align: left;
  padding: 10px 12px;
  border: thin solid #CCCCCC;
  cursor: pointer;
  border-radius: 5px;
}

.imgs {
  width: 150px;
  flex-shrink: 0;
  overflow: hidden;
}

.cont-img {
  width: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
}

img {
  width: 62px;
  height: 20px;
  object-fit: cover;
  border-radius: 3px;
}
</style>
